import './website-ui/i18n/config';

import {initBookmarks, renderBookmarksList, renderBookmarksTooltipOnBurgerButton} from './modules/bookmarks';

renderBookmarksTooltipOnBurgerButton(document.querySelector('.js-bookmarks-tooltip'));
renderBookmarksList(document.querySelector('.js-bookmarks-list'));

initBookmarks();
